import React from 'react';
// import imgx from '../../assets/bg.svg';
import '../../tagline.css'
// import bannerpic from '../../assets/banner pic1.png';

const TagLine = () => {

    return (
        <div className="bgImg" >
            <div class="container d-flex align-self-center justify-content-center">
                <div class="row justify-content-center">
                    <div class="col-xl-7 col-lg-9 text-center">
                        <h1 className="tag-h1">The New Social Way Of Reading and Sharing Documents</h1>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default TagLine;